import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPresentation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#3a3a3a",
			d: "M3.502 7.867a.125.125 0 0 0 .177 0l1.59-1.591 1.346 1.347a.125.125 0 0 0 .176 0l3.536-3.54a.125.125 0 0 0 0-.176l-.575-.575a.125.125 0 0 0-.176 0L6.704 6.207 5.358 4.86a.125.125 0 0 0-.176 0L2.927 7.115a.125.125 0 0 0 0 .177z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3a3a3a",
			d: "M12.75 1.125H7.188v-1A.125.125 0 0 0 7.063 0h-.875a.125.125 0 0 0-.125.125v1H.5a.5.5 0 0 0-.5.5V9.75a.5.5 0 0 0 .5.5h5.569v.5l-2.575 1.69a.124.124 0 0 0-.036.17l.473.738v.002a.126.126 0 0 0 .174.036l2.52-1.653 2.52 1.653a.126.126 0 0 0 .174-.036v-.002l.473-.737a.125.125 0 0 0-.036-.172l-2.568-1.684v-.505h5.562a.5.5 0 0 0 .5-.5V1.625a.5.5 0 0 0-.5-.5m-.625 8h-11V2.25h11z"
		})
	]
});
const ForwardRef = forwardRef(SvgPresentation);
export { ForwardRef as ReactComponent };
